<template>
  <div class="message-container">
    <ul class="message-list">
      <li
          v-for="message in messages"
          :key="message.thread_id"
          @click="handleMessageClick(message)"
          :class="{'highlighted-message': isThreadNew(message.thread_id)}"
          class="message-item"
      >
        <button @click.prevent.stop="handleDelete(message.thread_id)" class="delete-button">
          <i class="fas fa-trash"></i>
        </button>

        <div class="message-info">
          <div class="author-details">
            <span class="author-name">{{ message.contact_user_name.toUpperCase() }}</span>
            <div class="author-meta">
              <span class="author-type">UserType-{{ message.contact_user_type.toLowerCase() }}</span>
              <span class="message-thread-id">ChatID-{{ message.thread_id }}</span>
            </div>
          </div>

          <span class="message-date">{{ formatDate(message.date_added) }}</span>
        </div>
        <div class="message-content">
          {{ message.preview }}
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import store from "@/store";
export default {
  props: {
    messages: {
      type: Array,
      required: true,
    },
  },
  computed: {
    ...mapGetters(
        'messages', ['getNewThreadMessages','getThreadMessages']
    ),
  },
  methods: {
    handleDelete(threadId) {
      store.dispatch('messages/DELETE_THREAD', threadId);
      const currentKey = `chatMessages-${threadId}`;
      store.dispatch('cards/REMOVE', currentKey)
    },
    isThreadNew(threadId) {
      const findThread = this.getThreadMessages.find((message) => message.status === 'unread' && message.thread_id === threadId);
      const findThreadNew = this.getNewThreadMessages.find((message) => message.thread_id === threadId);
      return !!findThread || !!findThreadNew;
    },
    handleMessageClick(message) {
      if (message !== this.$parent.selectedMessage) {
        this.$emit('select-message', message);
      }
    },
    formatDate(dateString) {
      const messageDate = new Date(dateString * 1000);
      const now = new Date();

      const sameDay = now.getDate() === messageDate.getDate() && now.getMonth() === messageDate.getMonth() && now.getFullYear() === messageDate.getFullYear();
      const previousDay = now.getDate() - 1 === messageDate.getDate() && now.getMonth() === messageDate.getMonth() && now.getFullYear() === messageDate.getFullYear();

      const formattedHours = messageDate.getHours().toString();
      const formattedMinutes = messageDate.getMinutes().toString().padStart(2, '0');

      if (sameDay) {
        return `Today, ${formattedHours}:${formattedMinutes}`;
      } else if (previousDay) {
        return `Yesterday, ${formattedHours}:${formattedMinutes}`;
      } else {
        return `${messageDate.getDate()}.${messageDate.getMonth()+1}.${messageDate.getFullYear()}, ${messageDate.getHours()}:${messageDate.getMinutes()}`;
      }
    }
  },
};
</script>

<style>
.message-container {
  display: flex;
  justify-content: center;
  padding: 20px;
  background-color: #f2f2f2;
}
.message-list {
  list-style-type: none;
  padding: 0;
  margin: 0;
  width: 100%;
}

.message-item {
  position: relative;
  cursor: pointer;
  margin-bottom: 20px;
  padding: 15px;
  border: 1px solid #ccc;
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0px 4px 6px 0px rgba(0,0,0,0.1);
}

.message-info {
  white-space: nowrap;
}

.author-name {
  font-weight: bold;
  color: #333;
}

.author-details {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.author-meta {
  display: flex;
  align-items: center;
  gap: 5px;
}
.author-type,
.message-thread-id {
  color: #888;
  font-size: 14px;
  margin: 0;
}

.message-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.message-metadata {
  font-size: 14px;
  color: #888;
}

.message-date {
  color: #888;
  font-size: 14px;
}

.message-content {
  color: #333;
  font-size: 16px;
}

.message-item:hover {
  background-color: #f5f5f5;
}
.highlighted-message {
  background-color: #E6E6FA;
  border: 2px solid #9370DB;
  box-shadow: 0px 4px 8px rgba(147, 112, 219, 0.3);
  transition: background-color 0.2s ease, border 0.2s ease;
  cursor: pointer;
}

.highlighted-message:hover {
  background-color: #D8BFD8;
  border-color: #BA55D3;
  box-shadow: 0px 6px 12px rgba(186, 85, 211, 0.4);
}

.message-item:hover {
  background-color: #f5f5f5;
}
.delete-button {
  position: absolute;
  top: 5px;
  right: 5px;
  background-color: transparent;
  color: #888;
  border: none;
  padding: 5px;
  border-radius: 50%;
  width: 25px;
  height: 25px;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  cursor: pointer;
  transition: color 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}

.delete-button:hover {
  color: #ff4d4f;
}

.delete-button i {
  font-size: 14px;
}


</style>
